import React from 'react';
import { Container, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './Header';
import SearchContextBar from './SearchContextBar';
import { appTheme } from '../../theme/appTheme';
// Removed SavedSearch import as props are removed

// Define strongly typed props for the layout component
interface AppLayoutProps {
  title: string;
  onShowDisclaimer: () => void;
  // Removed searchContextBarProps
  children: React.ReactNode;
}

/**
 * AppLayout - A consistent layout wrapper for the application
 * 
 * This component provides the main application structure including:
 * - Theme provider with CssBaseline
 * - Header with app title and navigation
 * - SearchContextBar with current search context
 * - Container for main content
 */
const AppLayout: React.FC<AppLayoutProps> = ({
  title,
  onShowDisclaimer,
  // Removed searchContextBarProps from destructuring
  children
}) => {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Header title={title} onShowDisclaimer={onShowDisclaimer} />
      <Container maxWidth={false} sx={{ mt: 2, mb: 2, px: 2 }}>
        {/* SearchContextBar now gets its data from hooks/context */}
        <SearchContextBar />
        <Paper sx={{ p: 1, mb: 1 }}>
          {children}
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default AppLayout;
